import { render, staticRenderFns } from "./ConfirmationDialogWithInputField.vue?vue&type=template&id=65bbd533"
import script from "./ConfirmationDialogWithInputField.vue?vue&type=script&lang=js"
export * from "./ConfirmationDialogWithInputField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports